import { AuctionStatusEnum } from "../../../enums/AuctionStatus";
import { DomainStatusEnum } from "../../../enums/DomainStatus";

export type AllAuctionsTableProps = {
    pageType: "active" | "archived";
};

export type RequestType = {
    query: {
        page: number;
        size: number;
        filterAnd?: any[];
        filterOr?: any[];
        sort: {
            key: string;
            order: "ASC" | "DESC";
        };
    };
    archived: boolean;
    autoCancelled: boolean;
};

export interface AuctionActionRequestType {
    auctionIds: number[];
    action: string;
    value: boolean;
}

export const auctionNormalStatus = {
    Locked: AuctionStatusEnum.LOCKED,
    Ongoing: AuctionStatusEnum.ONGOING,
    "Payment Pending": AuctionStatusEnum.PAYMENT_PENDING,
};

export const auctionArchiveStatus = {
    Archived: "Archived",
    Cancelled: AuctionStatusEnum.CANCELLED,
    Closed: AuctionStatusEnum.CLOSED,
    Default: AuctionStatusEnum.DEFAULT,
};

export const domainStatus = {
    Success: DomainStatusEnum.SUCCESS,
    "Auto Renewed": DomainStatusEnum.AUTO_RENEWED,
    Cancelled: DomainStatusEnum.CANCELLED,
    "Not Found": DomainStatusEnum.DOMAIN_NOT_FOUND,
    Failure: DomainStatusEnum.FAILURE,
    "Not Processed": DomainStatusEnum.NOT_PROCESSED,
    Skipped: DomainStatusEnum.SKIPPED,
};
